import { AssemblyTypeKey } from '@ecosconnect/core/src/types/jobFormData';

const backflowTestResultTitle = ({
  assemblyType,
  index,
  testDate,
}: {
  assemblyType: AssemblyTypeKey;
  index: number;
  testDate?: string;
}) => {
  let title =
    assemblyType === 'AIR_GAP'
      ? 'Inspection'
      : index === 0
        ? 'Test'
        : 'Final Test';

  if (testDate) {
    title += ` – ${testDate}`;
  }

  return title;
};

export default backflowTestResultTitle;
